import { IApplicationState } from '../../types/redux';

export const selectSuburbanRkTitle = (state: IApplicationState) => {
  return state.suburbanRk?.title;
};
